const { directive } = require("vee-validate")

window.az = new Object()


az.page = function () {
    return app.$route.matched[0].instances.default
}

az.noSlash = function (path) {
    return path.replace(/\/+$/, '')
}

az.addRemSpinner = function (addRem, classId, id) {
    if (addRem) {
        if (classId == 'class') {
            var el = document.getElementsByClassName(id)
            for (var i = 0; i < el.length; i++) {
                el.item(i).classList.add('is-loading')
            }
        } else {
            if(document.getElementById(id) != undefined)
                document.getElementById(id).classList.add('is-loading');
        }
    } else {
        if (classId == 'class') {
            var el = document.getElementsByClassName(id)
            for (var i = 0; i < el.length; i++) {
                el.item(i).classList.remove('is-loading')
            }
        } else {
            if(document.getElementById(id) != undefined)
                document.getElementById(id).classList.remove('is-loading');
        }
    }
}

az.addRemSpinner2 = function (addRem, classId, id) {
    if (addRem) {
        if (classId == 'class') {
            var el = document.getElementsByClassName(id)
            for (var i = 0; i < el.length; i++) {
                el.item(i).classList.add('is-loading3')
            }
        } else {
            if(document.getElementById(id) != undefined)
                document.getElementById(id).classList.add('is-loading3');
        }
    } else {
        if (classId == 'class') {
            var el = document.getElementsByClassName(id)
            for (var i = 0; i < el.length; i++) {
                el.item(i).classList.remove('is-loading3')
            }
        } else {
            if(document.getElementById(id) != undefined)
                document.getElementById(id).classList.remove('is-loading3');
        }
    }
}

function decode(s) {
    return decodeURIComponent(s.replace(/\+/g, ' '));
} 

az.getCookieValue = function(key) {
    var cookies = document.cookie.split('; ');
    for (var i = 0, parts; (parts = cookies[i] && cookies[i].split('=')); i++) {
      if (decode(parts.shift()) === key) {
        return decode(parts.join('='));
      }
    }
    return null;
}

az.getQueryVariable = function(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

// Handle click outside to close dropdown menus
az.hideOnClickOutside = function (id, excluded) {
    function outsideClickListener(event) {
        if (!excluded.includes(event.target.id)) {
            document.getElementById(id).classList.remove('is-active')
            removeClickListener()
        }
    }
    function removeClickListener() {
        document.removeEventListener('click', outsideClickListener)
    }
    document.addEventListener('click', outsideClickListener)
}

az.copyToClipboard = str => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

az.dateConvert = function(date){
    var d = new Date(date);
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
}

az.overlaySorter = function(site, url, img){

    if(!url)
        return '---'

    //overlay stuff

   /*  if(img && (img.substring(0, 46) == 'https://miimuimg.s3.amazonaws.com/m-ii-default' || img.substring(0, 41) != 'https://miimuimg.s3.amazonaws.com/m-ii-BG')){
        console.log(img.substring(0, 48))
        return ''
    } */
    
    if(url.substring(url.length - 4).toLowerCase() == '.pdf'){
        return 'pdf'
    } else if(site == 'www.dropbox.com' && url.split('/s/').length > 1){
       return 'dropbox'
    } else if((site == 'trello.com' || site == 'www.trello.com') && (url.split('/c/').length > 1 || url.split('/b/').length > 1)) {
       return 'trello'
    } else if(site == 'docs.google.com' && url.split('spreadsheets/d/').length > 1 || site == 'drive.google.com') {
        return 'googlesheets'
    } else if(site == 'docs.google.com' && url.split('document/d/').length > 1 ) {
        return 'googledocs'
    } else if(site == 'mail.google.com' && url.split('/mail/').length > 1 ) {
        return 'gmail'
    } else if(site == 'youtube.com' || site == 'www.youtube.com') {
        return 'youtube'
    } else if(site == 'spotify.com' || site == 'www.spotify.com') {
        return 'spotify'
    } else if(site == 'pinterest.com' || site == 'www.pinterest.com') {
        return 'pintrest'
    } else if(site == 'whatsapp.com' || site == 'www.whatsap.com') {
        return 'whatsapp'
    } else if(site == 'linkedin.com' || site == 'www.linkedin.com') {
        return 'linkedin'
    } else if(site == 'twitter.com' || site == 'www.twitter.com' || site == 'x.com' || site == 'www.x.com') {
        return 'twitter'
    } else if(site == 'instagram.com' || site == 'www.instagram.com') {
        return 'instagram'
    } else if(site == 'tumblr.com' || site == 'www.tumblr.com') {
        return 'tumblr'
    } else if(site == 'facebook.com' || site == 'www.facebook.com') {
        return 'facebook'
    } else if(site == 'dribble.com' || site == 'www.dribble.com') {
        return 'dribble'
    } else if(site == 'gmail.com' || site == 'www.gmail.com') {
        return 'gmail'
    }

}

az.getRandomInt = function (max) {
    return Math.floor(Math.random() * Math.floor(max));
}


az.convertATagsToSelf = function (htmlString) {
    // Create a DOMParser
    let parser = new DOMParser();
    let doc = parser.parseFromString(htmlString, "text/html");

    // Get all <a> tags
    let links = doc.querySelectorAll("a");

    // Loop through links and update target attribute
    links.forEach(link => {
        console.log(link.href)
        if (link.href.includes('miimu.com')) {
            link.target = "_self";
        }
    });

    // Return the modified HTML string
    return doc.body.innerHTML;
}







